module.exports = __webpack_public_path__ + "img/background-main-kvota-eng.752b88d7.svg";